import { Routes } from '@angular/router';
import { authGuard } from '@components/auth/auth.guard';
import { adminRoleGuard } from '@components/auth/admin-role.guard';

export const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'login' },
    {
        path: 'login',
        loadComponent: () =>
            import('./components/auth/auth.component').then(
                (m) => m.AuthComponent,
            ),
    },
    {
        path: 'dashboard',
        canActivate: [authGuard],
        loadComponent: () =>
            import('./components/dashboard/dashboard.component').then(
                (m) => m.DashboardComponent,
            ),
    },
    {
        path: 'users-list',
        canActivate: [authGuard],
        data: { title: 'Пользователи' },
        loadComponent: () =>
            import('@components/users/users-list/users-list.component').then(
                (m) => m.UsersListComponent,
            ),
    },
    {
        path: 'survey-list',
        canActivate: [authGuard],
        data: { title: 'Исследования' },
        loadComponent: () =>
            import('@components/survey-list/survey-list.component').then(
                (m) => m.SurveyListComponent,
            ),
    },
    {
        path: 'product-list',
        canActivate: [authGuard],
        data: { title: 'Образцы' },
        loadComponent: () =>
            import(
                '@components/products/product-list/product-list.component'
            ).then((m) => m.ProductListComponent),
    },
    {
        path: 'categories-list',
        canActivate: [authGuard],
        data: { title: 'Категории' },
        loadComponent: () =>
            import(
                '@components/categories/categories-list/categories-list.component'
            ).then((m) => m.CategoriesListComponent),
    },
    {
        path: 'companies-list',
        canActivate: [authGuard, adminRoleGuard],
        data: { title: 'Компании' },
        loadComponent: () =>
            import('@components/companies/companies-list/companies-list.component').then(
                (m) => m.CompaniesListComponent,
            ),
    },
    {
        path: 'create',
        canActivate: [authGuard],
        loadComponent: () =>
            import('@components/wizard/edit-survey.component').then(
                (m) => m.EditSurveyComponent,
            ),
    },
    {
        path: 'create/:surveyId',
        canActivate: [authGuard],
        loadComponent: () =>
            import('@components/wizard/edit-survey.component').then(
                (m) => m.EditSurveyComponent,
            ),
    },
    {
        path: 'survey/go/:uuid',
        loadComponent: () =>
            import('@components/survey-answers/survey-answers.component').then(
                (m) => m.SurveyAnswersComponent,
            ),
    },
    {
        path: 'results/:id',
        data: { title: 'Отчеты' },
        loadComponent: () =>
            import('./components/results/results.component').then(
                (m) => m.ResultsComponent,
            ),
    },
    {
        path: 'results',
        data: { title: 'Отчеты' },
        loadComponent: () =>
            import('./components/results/results.component').then(
                (m) => m.ResultsComponent,
            ),
    },
    {
        path: 'monitoring/:id',
        canActivate: [authGuard],
        data: { title: 'Реал-тайм мониторинг' },
        loadComponent: () =>
            import(
                '@components/monitoring/real-time-monitoring.component'
            ).then((m) => m.RealTimeMonitoringComponent),
    },

    {
        path: 'scenarios',
        canActivate: [authGuard],
        loadComponent: () =>
            import(
                '@components/survey/scenario-builder/survey-builder.component'
            ).then((m) => m.SurveyBuilderComponent),
    },

    {
        path: 'download-report',
        canActivate: [authGuard],
        loadComponent: () =>
            import(
                '@components/download-report/download-report.component'
                ).then((m) => m.DownloadReportComponent),
    },

    {
        path: 'respondents',
        canActivate: [authGuard],
        loadComponent: () =>
            import(
                '@components/respondents/respondents.component'
                ).then((m) => m.RespondentsComponent),
    },
    {
        path: 'user-guide',
        canActivate: [authGuard],
        data: { title: 'Инструкция' },
        loadComponent: () =>
            import('@components/user-guide/user-guide.component').then(
                (m) => m.UserGuideComponent,
            ),
    },
    { path: '**', redirectTo: 'login' },
];
